module.exports = __webpack_public_path__ + "static/media/idVer.029ca552.png";